import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
  max-width: ${t => t.theme.desktopBreakpoint};
  margin: 0 auto;
  padding: 0 1.5rem;
  box-sizing: border-box;
`;

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};

function Container({ children }) {
  return (
    <StyledContainer>
      {children}
    </StyledContainer>
  );
}

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

export default Container;



// WEBPACK FOOTER //
// ./src/Components/Container/index.jsx